import { render } from "./Anamnesa.vue?vue&type=template&id=2e8dc9e2&scoped=true"
import script from "./Anamnesa.vue?vue&type=script&lang=js"
export * from "./Anamnesa.vue?vue&type=script&lang=js"

import "./Anamnesa.vue?vue&type=style&index=0&id=2e8dc9e2&scoped=true&lang=css"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8dc9e2"]])

export default __exports__